<header class="app-header">
  <dx-toolbar class="header-toolbar">

    <!-- Menu Toggle Button -->
    <dxi-toolbar-item *ngIf="menuToggleEnabled" location="before">
      <ng-container *dxTemplate>
        <button class="header-icon-btn menu-toggle-btn" (click)="toggleMenu()" type="button"
          title="{{ langService.currentLang === 'mr' ? 'मेनू उघडा/बंद करा' : 'Toggle Menu' }}" aria-label="Toggle Menu">
          <i class="dx-icon dx-icon-menu"></i>
        </button>
      </ng-container>
    </dxi-toolbar-item>

    <!-- Brand Logo -->
    <dxi-toolbar-item location="before" [cssClass]="'company-logo-item'">
      <ng-container *dxTemplate>
        <div class="header-logo-container">
          <img src="assets/icons/headericon_pink.png" alt="Asha Sathi" class="header-logo-img" />
        </div>
      </ng-container>
    </dxi-toolbar-item>

    <!-- Developer Cache Button -->
    <dxi-toolbar-item *ngIf="LoginRole === Roles.Developer" location="before">
      <ng-container *dxTemplate>
        <button (click)="RefreshDomainCache()" class="dev-cache-btn" [disabled]="isRefreshing"
          [class.spinning]="isRefreshing"
          title="{{ langService.currentLang === 'mr' ? 'कॅशे रीफ्रेश करा' : 'Refresh Domain Cache' }}" type="button">
          <i class="dx-icon dx-icon-refresh"></i>
          <span class="dev-cache-text">
            {{ langService.currentLang === 'mr' ? 'कॅशे रीफ्रेश' : 'Refresh Cache' }}
          </span>
        </button>
      </ng-container>
    </dxi-toolbar-item>

    <!-- Theme Switcher Placeholder (Preserved) -->
    <dxi-toolbar-item location="after" *ngIf="false">
      <ng-container *dxTemplate>
        <theme-switcher></theme-switcher>
      </ng-container>
    </dxi-toolbar-item>

    <!-- Right Header Actions (Location + Notification + User Profile) -->
    <dxi-toolbar-item location="after">
      <ng-container *dxTemplate>
        <div class="header-right-actions">

          <!-- Notification Bell Button -->
          <button class="header-icon-btn notification-btn" (click)="gotoNotification()" *ngIf="IsShowBtn"
            title="{{ langService.currentLang === 'mr' ? 'सूचना' : 'Notifications' }}" type="button"
            aria-label="Notifications">
            <i class="dx-icon dx-icon-bell"></i>
            <span class="notification-badge" *ngIf="notificationCount > 0">
              {{ notificationCount > 99 ? '99+' : notificationCount }}
            </span>
          </button>

          <!-- User Profile Panel (Pill trigger + dropdown) -->
          <app-user-panel [menuItems]="userMenuItems" [profileImage]="profileImageUrl"
            [userDisplayName]="UserDisplayName" [roleName]="RoleName" [locationText]="locationSummaryText">
          </app-user-panel>

          <!-- Location Badge (Desktop/Laptop) -->
          <div class="header-location-badge" *ngIf="PHCName || SCName || VillageName" [title]="locationSummaryText">
            <div class="loc-badge-icon">
              <i class="dx-icon dx-icon-map"></i>
            </div>
            <div class="loc-badge-content">
              <div class="loc-badge-row1" *ngIf="PHCName || SCName">
                <span class="loc-pill" *ngIf="PHCName">
                  <span class="loc-label">{{ langService.currentLang === 'mr' ? 'प्रा.आ.के.' : 'PHC' }}:</span>
                  <span class="loc-val">{{ PHCName }}</span>
                </span>
                <span class="loc-dot" *ngIf="PHCName && SCName">·</span>
                <span class="loc-pill" *ngIf="SCName">
                  <span class="loc-label">{{ langService.currentLang === 'mr' ? 'उपकेंद्र' : 'SC' }}:</span>
                  <span class="loc-val">{{ SCName }}</span>
                </span>
              </div>
              <div class="loc-badge-row2" *ngIf="VillageName">
                <span class="loc-label">{{ langService.currentLang === 'mr' ? 'गाव' : 'Village' }}:</span>
                <span class="loc-val">{{ VillageName }}</span>
              </div>
            </div>
          </div>

        </div>
      </ng-container>
    </dxi-toolbar-item>

    <!-- Preserved Menu Item Template -->
    <div *dxTemplate="let item of 'menuItem'">
      <div class="menu-item">
        <img *ngIf="item.isProfile" [src]="profileImageUrl || 'assets/icons/imgpreview.png'"
          (error)="$any($event.target).src = 'assets/icons/imgpreview.png'" class="profile-image" alt="Profile" />
        <i *ngIf="!item.isProfile && item.icon" class="dx-icon dx-icon-{{ item.icon }}"></i>
        <span class="menu-text">{{ item.text }}</span>
      </div>
    </div>

  </dx-toolbar>

  <!-- Breadcrumbs Deck -->
  <div class="breadcrumb-bar" *ngIf="breadcrumbs.length > 0">
    <div class="breadcrumb-scroll-wrap">
      <ng-container *ngFor="let crumb of breadcrumbs; let last = last; let first = first">
        <span class="crumb" [class.clickable]="!last && !!crumb.path" [class.current]="last"
          (click)="!last && crumb.path ? navigateBreadcrumb(crumb.path) : null"
          [attr.role]="!last && crumb.path ? 'button' : null" [attr.tabindex]="!last && crumb.path ? '0' : null">

          <i *ngIf="first" class="dx-icon dx-icon-home breadcrumb-home-icon"></i>

          <span class="crumb-text">
            {{ crumb.labelKey ? (crumb.labelKey | translate) : crumb.label }}
          </span>
        </span>

        <i class="dx-icon dx-icon-chevronright separator" *ngIf="!last"></i>
      </ng-container>
    </div>
  </div>

</header>